import React, { useState } from "react";
import { SubtitleContext } from "../../contexts/SubtitleContext";
import { LinkButton } from "rc-easyui";
import Popup from "reactjs-popup";
import TimeUtils from "../../helper/TimeUtils";

const FindFrameGap_Popup = ({ _WaveformView }) => {
  //網址判斷
  //     useEffect(() => {
  //
  //     }, [location]);

  const [startGap, setStartGap] = useState(2);
  const [endGap, setEndGap] = useState(11);

  //搜尋錯誤影格
  const searchFrameGapError = async () => {};

  return (
    <Popup
      open={_WaveformView.state.isShowFrameGapError}
      modal
      closeOnDocumentClick
      onClose={() => {
        _WaveformView.setState({ isShowFrameGapError: false });
      }}
      contentStyle={{ width: "450px" }}
    >
      <SubtitleContext.Consumer>
        {(context) => (
          <div
            title="Find Frame Split"
            style={{ width: "450px" }}
            ref={(ref) => (_WaveformView.dlg = ref)}
          >
            <h3>Find Frame Gap Error</h3>
            <form className=" ">
              <div className="form-group">
                <label htmlFor="inputAddress">Start: </label>

                <input
                  id="fFrameSplit"
                  style={{ width: "30px" }}
                  type="text"
                  placeholder="Frame Split"
                  value={startGap}
                  onChange={(event) => {
                    if (isNaN(event.target.value) === true) {
                    } else {
                      setStartGap(event.target.value);
                    }
                  }}
                />
              </div>
              <div className="form-group">
                <label htmlFor="inputAddress">End: </label>

                <input
                  id="fFrameSplit"
                  style={{ width: "30px" }}
                  type="text"
                  placeholder="Frame Split"
                  value={endGap}
                  onChange={(event) => {
                    if (isNaN(event.target.value) === true) {
                    } else {
                      setEndGap(event.target.value);
                    }
                  }}
                />
              </div>
              <div style={{ marginBottom: "20px" }}>
                <LinkButton
                  onClick={() => {
                    //開始搜尋
                    _WaveformView.props.updateFindFrameGapTargetData(
                      _WaveformView.DataObjArray.getContent(),
                      TimeUtils.getFPS(),
                      parseFloat(startGap),
                      parseFloat(endGap)
                    );
                    
                    //關掉視窗
                    _WaveformView.setState({ isShowFrameGapError: false });

                    //顯示列表
                    _WaveformView.setState({ isShowFindFrameGapList: true });
                  }}
                >
                  Confirm
                </LinkButton>
              </div>
            </form>
          </div>
        )}
      </SubtitleContext.Consumer>
    </Popup>
  );
};

export default FindFrameGap_Popup;



// WEBPACK FOOTER //
// ./src/components/popup/FindFrameGap_Popup.js